/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../../google/protobuf/timestamp";
import { WisePayoutStatus, wisePayoutStatusFromJSON, wisePayoutStatusToJSON } from "./WisePayoutStatus";

export const protobufPackage = "Reality.Reality.Api";

export interface WisePayout {
  id: string;
  /** 申請状態（ステータス） */
  status: WisePayoutStatus;
  /** 申請額 */
  amount: string;
  /** 送金申請日 */
  transferRequestedAt:
    | Date
    | undefined;
  /** 受取希望通貨 */
  preferredCurrency: string;
}

function createBaseWisePayout(): WisePayout {
  return { id: "", status: 0, amount: "", transferRequestedAt: undefined, preferredCurrency: "" };
}

export const WisePayout = {
  encode(message: WisePayout, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.transferRequestedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.transferRequestedAt), writer.uint32(34).fork()).ldelim();
    }
    if (message.preferredCurrency !== "") {
      writer.uint32(42).string(message.preferredCurrency);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WisePayout {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWisePayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.transferRequestedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.preferredCurrency = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WisePayout {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status) ? wisePayoutStatusFromJSON(object.status) : 0,
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      transferRequestedAt: isSet(object.transferRequestedAt)
        ? fromJsonTimestamp(object.transferRequestedAt)
        : undefined,
      preferredCurrency: isSet(object.preferredCurrency) ? globalThis.String(object.preferredCurrency) : "",
    };
  },

  toJSON(message: WisePayout): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.status !== 0) {
      obj.status = wisePayoutStatusToJSON(message.status);
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.transferRequestedAt !== undefined) {
      obj.transferRequestedAt = message.transferRequestedAt.toISOString();
    }
    if (message.preferredCurrency !== "") {
      obj.preferredCurrency = message.preferredCurrency;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WisePayout>, I>>(base?: I): WisePayout {
    return WisePayout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WisePayout>, I>>(object: I): WisePayout {
    const message = createBaseWisePayout();
    message.id = object.id ?? "";
    message.status = object.status ?? 0;
    message.amount = object.amount ?? "";
    message.transferRequestedAt = object.transferRequestedAt ?? undefined;
    message.preferredCurrency = object.preferredCurrency ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
